// extracted by mini-css-extract-plugin
module.exports = {"card":"SmallCard_card__HWAq8","angle":"SmallCard_angle__IQQcd","title":"SmallCard_title__1HKoO"};